import { Page } from '@shopify/polaris';

const CoreLayout = ({ children }: { children: JSX.Element | null }) => (
  <Page title="Captiv8">{children}</Page>
);

export default CoreLayout;
